import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';


// Components
import ModalHeader from '@common-components/headers/ModalHeader';
import Button from '@common-components/button/Button';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';

//Containers
import { configs } from '@constants/configs/configs';

import { environmentSelector } from '@selectors/commonSelectors';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import useSelfDesignationOtpRole from '../hooks/useSelfDesignationOtpRole';


const BecomeAORModal = ( props ) => {
    const {
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                memberName,
                handleAddToBOBClick
            }
        },
        modalHeaderProps,
        modalHeaderProps: {
            modalId
        }
    } = props;

    const { endpoints } = configs;
    const { activeModuleName } = useSelector(environmentSelector).user;

    const handleRestorationClick = () => {
        const normalizedRole = activeModuleName.toUpperCase(); 
        const redirectUrl = normalizedRole === ALL_USER_ROLES.ASSISTER ? endpoints.BACK_TO_ASSISTER_DASHBOARD : endpoints.BACK_TO_BROKER_DASHBOARD;
        window.location.href = redirectUrl;
    };

    const { role } = useSelfDesignationOtpRole();

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps, hideModal, hideModalCallback: handleRestorationClick } } />
            </div>
            <div className="gi-modal__body txt-left" id={`${modalId}_body`}>
                <h3>
                    <FormattedMessage
                        id={`selfDesignation.${role}.search.becomeAOR.modal.accept.content.1`}
                        values={{
                            name: memberName.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()),
                        }}
                        tagName='strong'
                    />
                </h3>
                <FormattedMessage
                    id={`selfDesignation.${role}.search.becomeAOR.modal.accept.content.2`}
                    values={{
                        name: memberName,
                        strong: function makeTextStrong (message) {
                            return (<strong>{message}</strong>);
                        }
                    }}
                    tagName='p'
                />
            </div>
            <div className='gi-modal__controls'>
                <Button
                    { ...{
                        id:`${modalId}-cancel-btn`,
                        name:'cancelBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'margin-r-10', 'display--inline'],
                        classes:['gi-button__secondary'],
                        btnText:'selfDesignation.search.action-btn.cancel',
                        handleClick: handleRestorationClick
                    }}

                />
                <Button
                    { ...{
                        id:`${modalId}-modal-yes-btn`,
                        name:'yesBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'display--inline'],
                        classes:['gi-button__primary'],
                        btnText:'selfDesignation.search.action-btn.yes',
                        handleClick: handleAddToBOBClick
                    }}

                />
            </div>
        </Fragment>
    );
};

export default BecomeAORModal;